module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/modules/_fails.js
// module id = 100
// module chunks = 0